export interface Tip {
  img: string;
  description: string;
  header: string;
  key: number;
}

export const tips: Tip[] = [
  {
    key: 0,
    header: 'Explore the editor',
    description:
      'Confluence is your playground.  To get a fresh start, just reload the page.',
    img: require(`../../assets/images/explore-editor.svg`)
  },
  {
    key: 1,
    header: 'Add new content',
    description:
      'Type / on the document to add emojis, actions items, and links',
    img: require(`../../assets/images/add-new-content.svg`)
  },
  {
    key: 2,
    header: 'Make it visual',
    description: 'Use dynamic layouts and tables to organize your ideas',
    img: require(`../../assets/images/make-it-visual.svg`)
  }
];
